'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _userUtil = require('../../user/userUtil');

require('./UserPlanBadge.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserPlanBadge = function UserPlanBadge(_ref) {
    var user = _ref.user;

    if (!(0, _userUtil.isSubscribed)(user)) return null;

    return _react2.default.createElement(
        'div',
        { className: 'UserPlanBadge' },
        'Pro'
    );
};

UserPlanBadge.propTypes = {
    user: _propTypes2.default.object
};

exports.default = UserPlanBadge;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/userAvatar/UserPlanBadge.js
// module id = 446
// module chunks = 0